import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as GLOBAL from '../../globals';

@Injectable()
export class InterceptorService implements HttpInterceptor {

    private presetHeaders: any;
    private xApiKey = GLOBAL.xApiKey;

    constructor() { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.presetHeaders = {
            'x-api-key': this.xApiKey
        };

        if (localStorage.getItem('act_agcl') != null) {
            this.presetHeaders.Authorization = 'Bearer ' + localStorage.getItem('act_agcl');
        } else if (sessionStorage.getItem('act_agcl') != null) {
            this.presetHeaders.Authorization = 'Bearer ' + sessionStorage.getItem('act_agcl');
        }

        req = req.clone({ setHeaders: this.presetHeaders });

        return next.handle(req);
    }
}
